// USA
export const locale = {
  title: {
    title: 'OJOUR',
  },
  nav: {
    notification: 'Notification',
    surveyYear: 'Survey Year',
    language: 'Lang',
    signout: 'Sign Out',
    login: 'Login',
    register: 'Register',
  },
  leftMenu: {
    home: 'Home',
    users: 'System Users',
    subscription: 'Subscription',
    subscriptionRequests: 'Subscription Requests',
    subscriptionList: {
      manageSubscriptionPackage: 'Subscription Packages',
      manageSubscriptions: 'Manage Subscriptions',
    },
    structureLookup: 'Structure Lookup',
    structureLookupList: {
      economicSector: 'Economic Sector',
      industryType: 'Industry Type',
      businessSector: 'Business Sector',
      businessSubSector: 'Business Sub-Sector',
      subscriptionType: 'Subscripion Type',
      jobFamily: 'Job Family',
      jobTitle: 'Job Title',
      setup: 'Setup',
      setupList: {
        surveyYear: 'Survey Year',
        legalStructureLookup: 'Legal Structure Lookup',
      },
    },
    marketAnalysis: 'Market Analysis',
    marketAnalysisList: {
      marketInsights: 'Market Insights',
      marketPayTrends: 'Market Pay Trends',
    },
    customer: {
      customers: 'Customers',
      profile: 'Company Profile',
      benefits: 'Benefits',
      positionMapping: 'Position Mapping',
      waitingPositionMapping: 'Position Mapping approve',
      analysisReport: 'Analysis Report',
      positionReport: 'Position Report',
      reportGenerator: 'Report Generator',
      dashboard: 'Dashboard',
      jobTitles: 'Job Titles',
      reports: 'Reports',
    },
  },
  registerationPackages: {
    register: 'Register',
    packagePeriod: 'Package Period',
    numberOfUsers: 'Number Of Users',
    numberOfBusinessSectors: 'Number Of Business Sectors',
    subscribe: 'Subscribe',
  },
  login: {
    login: 'Login',
    username: 'User Name',
    password: 'Passeword',
    register: 'Register',
    donothaveaccount: "Don't have an account yet?",
    enteruserpassword: 'Welcome to OJOUR, Enter your username and password',
  },
  adminDashboard: {
    dashboard: 'Dashboard',
    report1Header: 'Number of Survey Customers Participants Till today',
    report2Header: 'Customers data completion percent todate',
    systemNotification: 'System Notification',
    Task: 'Task',
    Ticket: 'Ticket',
    Meeting: 'Meeting',
    All: 'All',
    Scheduled: 'Scheduled',
    InProgress: 'InProgress',
    Done: 'Done',
    System: 'System',
    Admin: 'Admin',
    Customer: 'Customer',
    Me: 'Me',
    Normal: 'Normal',
    High: 'High',
    id: 'id',
    notificationType: 'notification Type',
    notificationTime: 'notification Time',
    importance: 'importance',
    notificationStatus: 'notification Status',
  },
  users: {
    users: 'System Users',
    roles: 'Roles',
    addUser: 'Add User',
    grid: {
      name: 'Name',
      arabicName: 'Arabic Name',
      userName: 'User Name',
      password: 'Password',
      mobile: 'Mobile Number',
      gender: 'Gender',
      joinDate: 'Join Date',
      eMail: 'E-Mail',
      notes: 'Notes',
      User_Rights: 'User Rights',
      action: 'Action',
    },
    confirmPassword: 'Confirm Password',
    rolesList: {
      superAdmin: 'Super Admin',
      customerSupport: 'Customer Support',
      systemAdmin: 'System Admin',
      user: 'User',
    },
    add: 'Add',
    update: 'Update',
    addNew: 'Add New User',
    edit: 'Edit System User',
  },
  registerationManage: {
    id: 'id',
    legalName: 'Legal Name',
    commercialName: 'commercial Name',
    legalStructure: 'Legal Structure',
    yearOfEstablishment: 'Year Of Establishment',
    industryType: 'Industry Type',
    businessSector: 'Business Sector',
    businessSubSector: 'Business Sub-Sector',
    contactPerson: 'Contact Person',
    contactPersonMail: 'Contact Person Mail',
    contactPersonMobile: 'Contact Person Website',
    webSite: 'webSite',
    Action: 'Action',
    remove: 'Rempve',
    registerationMgr: 'Registeration Manager',
    noRegisterations: 'No registerationes Yet',
  },
  subscriptionPackages: {
    grid: {
      id: 'id',
      packageName: 'Package Name',
      packagePeriodName: 'Package Period Name',
      numberOfBusinessSectors: 'Number Of Business Sectors',
      numberOfUsers: 'Number Of Users',
      Action: 'Action',
      Reports: 'Reports',
    },
    title: 'Manage Supscription Packages',
    add: 'Add Subscription Package',
    edit: 'Edit Subscription Package',
    update: 'Update',
    submit: 'Submit',
    packageName: 'Package Name',
    packagePeriod: 'Package Period',
    businessSector: 'Business Sector',
    numberOfUsers: 'Number Of Users',
    noPackages: 'No Subscription Packages yet',
  },
  surveyYear: {
    title: 'Survey year',
    add: 'Add Survey year',
    grid: {
      year: 'year',
      startDate: 'Start Date',
      endDate: 'End Date',
      isActive: 'Is Active',
      Action: 'Action',
    },
    startDate: 'Start Date',
    endDate: 'End Date',
    submit: 'Add',
    update: 'Update',
    addHeader: 'Add Survey Year',
    editHeader: 'Edit Survey Year',
  },
  legalStructure: {
    title: 'Legal Structure',
    add: 'Add Legal Structure',
    grid: {
      id: 'id',
      englishName: 'English Name',
      arabicName: 'Arabic Name',
      Action: 'Action',
    },
    englishName: 'English Name',
    arabicName: 'Arabic Name',
    submit: 'Add',
    update: 'Update',
    addHeader: 'Add Legal Structure',
    editHeader: 'Edit Legal Structure',
  },
  economicSector: {
    title: 'Economic Sector',
    add: 'Add Economic Sector',
    grid: {
      id: 'id',
      englishName: 'English Name',
      arabicName: 'Arabic Name',
      Action: 'Action',
    },
    englishName: 'English Name',
    arabicName: 'Arabic Name',
    submit: 'Add',
    update: 'Update',
    addHeader: 'Add Economic Sector',
    editHeader: 'Edit Economic Sector',
  },
  IndustryType: {
    title: 'Industry Type',
    add: 'Add Industry Type',
    grid: {
      id: 'id',
      economicSectorName: 'Economic Sector Name',
      englishName: 'English Name',
      arabicName: 'Arabic Name',
      Action: 'Action',
    },
    economicSector: 'Economic Sector',
    englishName: 'English Name',
    arabicName: 'Arabic Name',
    submit: 'Add',
    update: 'Update',
    addHeader: 'Add Industry Type',
    editHeader: 'Edit Industry Type',
  },
  BusinessSector: {
    title: 'Business Sector',
    add: 'Add Business Sector',
    grid: {
      id: 'id',
      industryTypeName: 'Industry Type Name',
      englishName: 'English Name',
      arabicName: 'Arabic Name',
      Action: 'Action',
    },
    industryType: 'Industry Type',
    englishName: 'English Name',
    arabicName: 'Arabic Name',
    submit: 'Add',
    update: 'Update',
    addHeader: 'Add Business Sector',
    editHeader: 'Edit Business Sector',
  },
  TRANSLATOR: {
    SELECT: 'Select your language',
  },
  MENU: {
    NEW: 'new',
    ACTIONS: 'Actions',
    CREATE_POST: 'Create New Post',
    PAGES: 'Pages',
    FEATURES: 'Features',
    APPS: 'Apps',
    DASHBOARD: 'Dashboard',
  },
  AUTH: {
    GENERAL: {
      OR: 'Or',
      SUBMIT_BUTTON: 'Submit',
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: 'Sign Up',
      FORGOT_BUTTON: 'Forgot Password',
      BACK_BUTTON: 'Back',
      PRIVACY: 'Privacy',
      LEGAL: 'Legal',
      CONTACT: 'Contact',
    },
    LOGIN: {
      TITLE: 'Login Account',
      BUTTON: 'Sign In',
    },
    FORGOT: {
      TITLE: 'Forgot Password?',
      DESC: 'Enter your email to reset your password',
      SUCCESS: 'Your account has been successfully reset.',
    },
    REGISTER: {
      TITLE: 'Sign Up',
      DESC: 'Enter your details to create your account',
      SUCCESS: 'Your account has been successfuly registered.',
    },
    INPUT: {
      EMAIL: 'Email',
      FULLNAME: 'Fullname',
      PASSWORD: 'Password',
      CONFIRM_PASSWORD: 'Confirm Password',
      USERNAME: 'Username',
    },
    VALIDATION: {
      INVALID: '{{name}} is not valid',
      REQUIRED: '{{name}} is required',
      MIN_LENGTH: '{{name}} minimum length is {{min}}',
      AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
      NOT_FOUND: 'The requested {{name}} is not found',
      INVALID_LOGIN: 'The login detail is incorrect',
      REQUIRED_FIELD: 'Required field',
      MIN_LENGTH_FIELD: 'Minimum field length:',
      MAX_LENGTH_FIELD: 'Maximum field length:',
      INVALID_FIELD: 'Field is not valid',
    },
  },
  ECOMMERCE: {
    COMMON: {
      SELECTED_RECORDS_COUNT: 'Selected records count: ',
      ALL: 'All',
      SUSPENDED: 'Suspended',
      ACTIVE: 'Active',
      FILTER: 'Filter',
      BY_STATUS: 'by Status',
      BY_TYPE: 'by Type',
      BUSINESS: 'Business',
      INDIVIDUAL: 'Individual',
      SEARCH: 'Search',
      IN_ALL_FIELDS: 'in all fields',
    },
    ECOMMERCE: 'eCommerce',
    CUSTOMERS: {
      CUSTOMERS: 'Customers',
      CUSTOMERS_LIST: 'Customers list',
      NEW_CUSTOMER: 'New Customer',
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: 'Customer Delete',
        DESCRIPTION: 'Are you sure to permanently delete this customer?',
        WAIT_DESCRIPTION: 'Customer is deleting...',
        MESSAGE: 'Customer has been deleted',
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: 'Customers Delete',
        DESCRIPTION: 'Are you sure to permanently delete selected customers?',
        WAIT_DESCRIPTION: 'Customers are deleting...',
        MESSAGE: 'Selected customers have been deleted',
      },
      UPDATE_STATUS: {
        TITLE: 'Status has been updated for selected customers',
        MESSAGE: 'Selected customers status have successfully been updated',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Customer has been updated',
        ADD_MESSAGE: 'Customer has been created',
      },
    },
  },
};
